// extracted by mini-css-extract-plugin
export default {"logo":"MyCompanies_logo__pYJV1"};